// import { FC, useEffect, useLayoutEffect, useMemo, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import LeftSideMenu from "../../components/LeftSideMenu/LeftSideMenu";
// import useGetwidth from "../../CustomHooks/useGetWidth";
// import { RootState } from "../../redux/rootReducers";
// import * as pageLoader from "../../Services/Loader";
// import "./../../components/LeftSideMenu/LeftSideMenu.scss";
// import { MerchantEx } from "../../models";
// import { useParams } from "react-router-dom";
// import { RemovePartnerData } from "../../../src/redux/actions/getPartnerById";
// import { RemoveMerchantData } from "../../../src/redux/actions/getMerchantById";

// interface LayoutProps {
//   children?: any;
//   type: string;
// }

// const Layout: FC<LayoutProps> = ({ children, type }) => {
//   const authApi = useSelector((state: RootState) => state.authReducer);
//   const merchantApi: {
//     merchantData: MerchantEx;
//     loading: boolean;
//     error: null | string;
//     merch_id: string;
//   } = useSelector((state: RootState) => state.merchantReducer);
//   const getPartnerApi: any = useSelector(
//     (state: RootState) => state.partnerReducer
//   );

//   const { acountTypeReport, partnerId, accountType }: any = useParams();
//   const { width } = useGetwidth();
//   const dispatch = useDispatch();
//   useLayoutEffect(() => {
//     if (
//       accountType != "partner" &&
//       type != "partner" &&
//       accountType === "admin" &&
//       type === "admin"
//     ) {
//       dispatch(RemovePartnerData());
//     }
//     if (accountType != "merchant" && type != "merchant") {
//       dispatch(RemoveMerchantData());
//     }
//   }, [accountType]);

//   //dont go to the user page first you have to call api to get merchant data or partner data

//   useEffect(() => {
//     pageLoader.stopLoading();
//   }, []);

//   const leftSideNavbar = useMemo(() => {
//     if (type && type != "false" && authApi.token && merchantApi.merch_id) {
//       return (
//         <LeftSideMenu width={width} type={type} userId={merchantApi.merch_id} />
//       );
//     } else if (
//       type &&
//       type != "false" &&
//       authApi.token &&
//       authApi.role === "partner"
//       //   getPartnerApi?.partnerId
//     ) {
//       return (
//         <LeftSideMenu
//           width={width}
//           type={"partner"}
//           userId={partnerId || getPartnerApi?.partnerId}
//         />
//       );
//     } else if (
//       type &&
//       type != "false" &&
//       authApi.token &&
//       authApi.role === "admin"
//     ) {
//       return <LeftSideMenu width={width} type={"admin"} />;
//     }
//   }, [type, accountType, merchantApi.merch_id, getPartnerApi?.partnerId]);

//   return (
//     <>
//       {leftSideNavbar}
//       {children}
//     </>
//   );
// };

// export default Layout;
import { FC, useEffect, useLayoutEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import LeftSideMenu from "../../components/LeftSideMenu/LeftSideMenu";
import useGetwidth from "../../CustomHooks/useGetWidth";
import { RootState } from "../../redux/rootReducers";
import * as pageLoader from "../../Services/Loader";
import "./../../components/LeftSideMenu/LeftSideMenu.scss";
import { MerchantEx } from "../../models";
import { useParams } from "react-router-dom";
import { RemovePartnerData } from "../../redux/actions/getPartnerById";
import { RemoveMerchantData } from "../../redux/actions/getMerchantById";

interface LayoutProps {
  children?: React.ReactNode;
  type: string;
}

const Layout: FC<LayoutProps> = ({ children, type }) => {
  const { token, role } = useSelector((state: RootState) => state.authReducer);
  const merchantApi = useSelector(
    (state: RootState) => state.merchantReducer
  ) as {
    merchantData: MerchantEx;
    loading: boolean;
    error: string | null;
    merch_id: string;
  };
  const partnerApi = useSelector(
    (state: RootState) => state.partnerReducer
  ) as {
    partnerId?: string;
  };

  const { partnerId: paramPartnerId } = useParams<{ partnerId?: string }>();

  const { width } = useGetwidth();
  const dispatch = useDispatch();

  // Clear out stale merchant or partner data when type changes
  useLayoutEffect(() => {
    if (type !== "merchant") {
      dispatch(RemoveMerchantData());
    }
    if (type !== "partner") {
      dispatch(RemovePartnerData());
    }
  }, [type, dispatch]);

  useEffect(() => {
    pageLoader.stopLoading();
  }, []);

  const leftSideNavbar = useMemo(() => {
    if (!token || !type || type === "false") return null;

    if (type === "public") {
      return null;
    }

    if (type === "partner") {
      const id = paramPartnerId || partnerApi.partnerId;
      if (id) {
        return <LeftSideMenu width={width} type="partner" userId={id} />;
      }
      return null;
    }

    if (type === "merchant") {
      if (merchantApi.merch_id) {
        return (
          <LeftSideMenu
            width={width}
            type="merchant"
            userId={merchantApi.merch_id}
          />
        );
      }
      return <LeftSideMenu width={width} type="merchant" />;
    }

    if (type === "admin") {
      return <LeftSideMenu width={width} type="admin" />;
    }

    return null;
  }, [
    token,
    type,
    width,
    paramPartnerId,
    partnerApi.partnerId,
    merchantApi.merch_id,
  ]);

  return (
    <>
      {leftSideNavbar}
      {children}
    </>
  );
};

export default Layout;
